module.exports = __webpack_public_path__ + "img/bdac-logo.d0a2529b.svg";